import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'

/* global __webpack_hash__ */
// Version stamp for the locale URLs: the webpack compilation hash changes with every build, so a
// new release always asks the CDN for a fresh copy (falls back to the page-load time, e.g. in tests).
const LOCALE_VERSION =
  process.env.REACT_APP_BUILD_ID ||
  (typeof __webpack_hash__ !== 'undefined' ? __webpack_hash__ : String(Date.now()))

i18n
  .use(HttpApi) // Load translations using http
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    supportedLngs: ['en', 'ar', 'fr'],
    fallbackLng: 'en',
    debug: false,

    // Detection options
    detection: {
      order: ['localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'],
    },

    // Locale files change with every release: never let the browser / CDN serve an old copy
    // (an outdated file shows raw keys such as "hrDashboard.viewOverview").
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
      queryStringParams: { v: LOCALE_VERSION },
      requestOptions: { cache: 'no-store' },
    },

    // an empty translation falls back to English instead of rendering nothing
    returnEmptyString: false,
    returnNull: false,

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    react: {
      useSuspense: true,
    },
  })

// Handle RTL/LTR direction change
i18n.on('languageChanged', (lng) => {
  const dir = lng === 'ar' ? 'rtl' : 'ltr'
  document.documentElement.dir = dir
  document.documentElement.lang = lng

  // Store direction in localStorage for persistence
  localStorage.setItem('direction', dir)
})

export default i18n
